var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconComposeLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconCompose",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true,
      children: _path || (_path = _jsx("path", {
        d: "M909.191 303.66v101.02h-808.17v1414.3H1515.32v-721.494h101.021V1920H0V303.66h909.191ZM1562.132 0c40.51 0 78.494 15.76 106.982 44.348l206.588 206.488c58.997 59.097 58.997 155.27 0 214.266L1666.184 674.62l-349.432-349.332-818.778 818.778 277.91 277.91 723.514-723.414 71.422 71.422-857.367 857.266-526.018 105.164 105.264-525.917L1454.848 44.348C1483.437 15.76 1521.522 0 1562.03 0ZM426.552 1215.488l-40.711 40.812-69.503 347.413 347.412-69.503 40.712-40.813-277.91-277.91Zm884.007-677.469 71.422 71.422-624.716 624.716-71.422-71.422 624.716-624.716Zm251.573-436.998h-.1c-13.538 0-26.165 5.253-35.762 14.75l-138.096 138.095 278.01 277.91L1804.28 393.68c19.598-19.7 19.598-51.723 0-71.523L1597.692 115.77c-9.597-9.597-22.225-14.749-35.56-14.749Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconComposeLine.glyphName = 'compose';
IconComposeLine.variant = 'Line';
IconComposeLine.displayName = 'IconComposeLine';
IconComposeLine.allowedProps = [...SVGIcon.allowedProps];
export default IconComposeLine;
export { IconComposeLine };